import { TextInputVerifyNumber } from './TextInputVerifyNumber'
import { withTextInputVerifyNumber } from './withTextInputVerifyNumber'

const ConnectedTextInputVerifyNumber = withTextInputVerifyNumber(
  TextInputVerifyNumber
)
export { ConnectedTextInputVerifyNumber as TextInputVerifyNumber }
